import * as React from "react";
import type { ListSelectionMode, ListStyle, ListVariant } from "./list-types";

export interface ListContextValue {
	selectionMode: ListSelectionMode;
	variant: ListVariant;
	listStyle: ListStyle;
	selectedValues: Set<string>;
	onItemChange: (value: string, selected: boolean) => void;
	reorderable: boolean;
	itemCount: number;
	outerRadius: number;
	innerRadius: number;
}

export const ListContext = React.createContext<ListContextValue | null>(null);

export const useListContext = () => React.useContext(ListContext);
export type { ListSelectionMode, ListStyle, ListVariant };
